export default "__VITE_ASSET__BIYadxcD__"